import { UserSegment } from '@/types/user';

export const INSTITUTIONAL_USER_SEGMENTS = [UserSegment.INSTITUTIONAL, UserSegment.MARKET_MAKER];

export const isInstitutionalUserSegment = (segment: unknown) => INSTITUTIONAL_USER_SEGMENTS.includes(segment as UserSegment);
